import React from 'react';
import { ToggleContainer, Section, SelectLabel, TooltipHelp, FrameCard } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import EmailsList from '../../../components/emailsList';
import LoadingCard from '../../../components/loadingCard';
import './notification.scss';

function Option({ loading, name, select = false, options = null, value = null, setForm, title, subTitle, toggleTitle, organization, addresses, toggle, onToggle }) {
    const { t } = useTranslation();

    return (
        <FrameCard title={title} subtitle={subTitle}>
            <LoadingCard loading={loading} height={'210px'}>
                <ToggleContainer className="toggle-container-notification" toggle={toggle} title={toggleTitle} onToggle={onToggle}>
                    {select && (
                        <div className="report-dropdown-options">
                            <SelectLabel
                                useNew
                                label={
                                    <>
                                        {t('notifications.order_notification-select')}
                                        <TooltipHelp className="" mini={false} title={t('notifications.main_orders_card_tooltip')} />
                                    </>
                                }
                                options={options}
                                value={value}
                                onChange={v => setForm('select_periodicity', v)}
                            />
                        </div>
                    )}
                    <Section className="notifications-emails-toggle">
                        <EmailsList organizerEmail={organization.email} setValue={v => setForm(name, v)} value={addresses} />
                    </Section>
                </ToggleContainer>
            </LoadingCard>
        </FrameCard>
    );
}

export default Option;
